export default "__VITE_ASSET__DhYwDZ3S__"